$(function () {
	var swiper = new Swiper('.swiper-container', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		loop: true,
		observer: true,
		observeParents: true,
		/*  autoplay: {
			delay: 3000
		  },*/
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			/*clickable: true,*/
		},
      simulateTouch: false,/*クリックでスワイプしない*/
		slidesPerView: 1,
		loopedSlides: 3,
		/*centeredSlides : true,*/
		slideToClickedSlide: true,
		spaceBetween: 20,
		slidesPerGroup: 1,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 3,
			}
		}
	});
	
	/*lazyload*/
	var lazyloadImages;

	if ("IntersectionObserver" in window) {
		lazyloadImages = document.querySelectorAll(".bg-lazy");
		var imageObserver = new IntersectionObserver(function (entries, observer) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					var image = entry.target;
					image.classList.remove("bg-lazy");
					imageObserver.unobserve(image);
				}
			});
		});

		lazyloadImages.forEach(function (image) {
			imageObserver.observe(image);
		});
	} else {
		var lazyloadThrottleTimeout;
		lazyloadImages = document.querySelectorAll(".bg-lazy");

		function lazyload() {
			if (lazyloadThrottleTimeout) {
				clearTimeout(lazyloadThrottleTimeout);
			}

			lazyloadThrottleTimeout = setTimeout(function () {
				var scrollTop = window.pageYOffset;
				lazyloadImages.forEach(function (img) {
					if (img.offsetTop < (window.innerHeight + scrollTop)) {
						img.src = img.dataset.src;
						img.classList.remove('bg-lazy');
					}
				});
				if (lazyloadImages.length == 0) {
					document.removeEventListener("scroll", lazyload);
					window.removeEventListener("resize", lazyload);
					window.removeEventListener("orientationChange", lazyload);
				}
			}, 20);
		}

		document.addEventListener("scroll", lazyload);
		window.addEventListener("resize", lazyload);
		window.addEventListener("orientationChange", lazyload);
	}
  /*スムーススクロール*/
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
  
/* スクロールで出現するヘッダーメニュー*/
  /**
	 * 現在スクロール位置によるグローバルナビのアクティブ表示
	 */
	var scrollMenu = function() {
		// 配列宣言
		// ここにスクロールで点灯させる箇所のidを記述する
		// 数値は全て0でOK
		var array = {
      '#page-top': 0,
			'#menu-1': 0,
			'#menu-3': 0,
            '#menu-4': 0,
          '#menu-5': 0
		};
		var $globalNavi = new Array();
		// 各要素のスクロール値を保存
		for (var key in array) {
			if ($(key).offset()) {
				array[key] = $(key).offset().top - 10; // 数値丁度だとずれるので10px余裕を作る
				$globalNavi[key] = $('.follow-menu ul li a[href="' + key + '"]');
			}
		}
		// スクロールイベントで判定
		$(window).scroll(function () {
			for (var key in array) {
				if ($(window).scrollTop() > array[key] - 50) {
					$('.follow-menu ul li a').each(function() {
						$(this).removeClass('active');
					});
					$globalNavi[key].addClass('active');
				}
			}
		});
	}
	// 実行
	scrollMenu();
  
  /*スクロールで表示*/
$(window).on('load scroll', function(){
  if ($(window).scrollTop() > 300) {
   $('.follow-menu').fadeIn(400);
   } else {
    $('.follow-menu').fadeOut(400);
  }
  });


  /*下線スクロール*/
$(window).scroll(function (){
    $(".js-marker").each(function(){
      var position = $(this).offset().top; //ページの一番上から要素までの距離を取得
      var scroll = $(window).scrollTop(); //スクロールの位置を取得
      var windowHeight = $(window).height(); //ウインドウの高さを取得
      if (scroll > position - windowHeight){ //スクロール位置が要素の位置を過ぎたとき
        $(this).addClass('active'); //クラス「active」を与える
      }
    });
});
  
      /*アコーディオンコンテンツ*/
     //.accordion-wrapの中のdt要素がクリックされたら
	$('.accordion-contents dt').click(function(){
 
		//クリックされた.accordion-contentsの中のdt要素に隣接するdd要素が開いたり閉じたりする。
		$(this).next('dd').slideToggle();
    
     /*矢印の向きを変更*/
    $(this).toggleClass('open');
 
	});

  
});